import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white pt-20 pb-10" data-id="element-124">
      <div className="container mx-auto px-4" data-id="element-125">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-12 mb-16 text-center md:text-left" data-id="element-126">
          {/* Brand Info */}
          <div className="col-span-2 md:col-span-1 flex flex-col items-center md:items-start" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/pKM35Hxacor8pvdYX3c3hd/pasted-image.png" alt="TriLyn Logo" className="h-16 md:h-20 mb-6 brightness-0 invert" data-id="element-128" />
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-129">
              Empowering culture through fashion. TriLyn brings you the finest
              handcrafted pieces that celebrate African heritage and modern
              style.
            </p>
            <div className="flex justify-center md:justify-start space-x-4" data-id="element-130">
              <a href="https://www.instagram.com/trilynllc/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-131">
                <Instagram size={20} data-id="element-132" />
              </a>
              <a href="https://www.facebook.com/TriLynLLC" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-133">
                <Facebook size={20} data-id="element-134" />
              </a>
              <a href="#" className="hover:text-gold transition-colors" data-id="element-135">
                <Twitter size={20} data-id="element-136" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-137">
            <h4 className="text-lg font-serif mb-6 text-gold" data-id="element-138">Shop</h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-139">
              <li data-id="element-140">
                <a href="#" className="hover:text-white transition-colors" data-id="element-141">
                  New Arrivals
                </a>
              </li>
              <li data-id="element-142">
                <a href="#" className="hover:text-white transition-colors" data-id="element-143">
                  Best Sellers
                </a>
              </li>
              <li data-id="element-144">
                <a href="#" className="hover:text-white transition-colors" data-id="element-145">
                  Accessories
                </a>
              </li>
              <li data-id="element-146">
                <Link to="/product/gift-card" className="hover:text-white transition-colors" data-id="element-147">
                  Gift Cards
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Care */}
          <div data-id="element-148">
            <h4 className="text-lg font-serif mb-6 text-gold" data-id="element-149">Information</h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-150">
              <li data-id="element-151">
                <a href="#" className="hover:text-white transition-colors" data-id="element-152">
                  Our Story
                </a>
              </li>
              <li data-id="element-153">
                <Link to="/policies" className="hover:text-white transition-colors" data-id="element-154">
                  Shipping Policy
                </Link>
              </li>
              <li data-id="element-155">
                <Link to="/policies" className="hover:text-white transition-colors" data-id="element-156">
                  Returns & Exchanges
                </Link>
              </li>
              <li data-id="element-157">
                <a href="#" className="hover:text-white transition-colors" data-id="element-158">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-159">
            <h4 className="text-lg font-serif mb-6 text-gold" data-id="element-160">Get In Touch</h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-161">
              <li className="flex items-center justify-center md:justify-start space-x-3" data-id="element-162">
                <MapPin size={18} className="text-gold" data-id="element-163" />
                <span data-id="element-164">123 Culture Way, Heritage City</span>
              </li>
              <li className="flex items-center justify-center md:justify-start space-x-3" data-id="element-165">
                <Phone size={18} className="text-gold" data-id="element-166" />
                <span data-id="element-167">+1 (555) 123-4567</span>
              </li>
              <li className="flex items-center justify-center md:justify-start space-x-3" data-id="element-168">
                <Mail size={18} className="text-gold" data-id="element-169" />
                <span data-id="element-170">hello@shoptrilyn.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-xs text-gray-500 uppercase tracking-widest" data-id="element-171">
          © {new Date().getFullYear()} TriLyn. All Rights Reserved.
        </div>
      </div>
    </footer>;
}